module.exports = __webpack_public_path__ + "img/arla-default-loading.b61bc765.jpg";